import React, { useState, useRef, Fragment, useEffect } from 'react';
import Img from "../../images/mail.png";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, resendEmailAction, verifyEmailAction, verifyEmailTimeAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import { RESEND_EMAIL_RESET } from '../../../redux/constants/userConstants';
import usePageMeta from '../../../hooks/usePageMeta';

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, expiryTime } = useSelector((state) => state.verifyTime);
    const {
        loading: resendEmailLoading,
        message,
        expireTime: resendEmailTime
    } = useSelector((state) => state.resendEmail);
    const { isAuthenticated, error, loading: verifyEmailLoading } = useSelector((state) => state.verifyEmailStore);

    // 6-digit code
    const [codes, setCodes] = useState(['', '', '', '', '', '']);
    // useRef to hold an array of input DOM nodes (do NOT call useRef in a callback)
    const inputRefs = useRef([]);

    const [time, setTime] = useState(120); // 2 minutes default
    const [ActuallTime, setActuallTime] = useState("02:00");
    const [email, setEmail] = useState("");

    usePageMeta("verifyEmail");

    // Timer tick
    useEffect(() => {
        if (time > 0) {
            const timer = setTimeout(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [time]);

    // Format time display
    useEffect(() => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        const formattedTime = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        setActuallTime(formattedTime);
    }, [time]);

    // Handle typing and focus movement
    const handleChange = (index, e) => {
        const { value } = e.target;
        // allow only single char per input
        if (value.length <= 1) {
            const newCodes = [...codes];
            newCodes[index] = value;
            setCodes(newCodes);

            if (value.length === 1 && index < codes.length - 1) {
                const next = inputRefs.current[index + 1];
                if (next) next.focus();
            } else if (value.length === 0 && index > 0) {
                const prev = inputRefs.current[index - 1];
                if (prev) prev.focus();
            }
        }
    };

    // Handle paste (allow pasting full 6-digit code)
    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text/plain').trim();
        const pastedChars = pasteData.split('').slice(0, codes.length);
        if (pastedChars.length === 0) return;

        const newCodes = [...codes];
        pastedChars.forEach((ch, idx) => {
            newCodes[idx] = ch;
        });
        setCodes(newCodes);

        // Focus the last filled input (or last input)
        const lastIndex = Math.min(pastedChars.length - 1, codes.length - 1);
        const el = inputRefs.current[lastIndex];
        if (el) el.focus();
    };

    const handleSubmit = () => {
        const tokenStr = codes.join('');
        if (tokenStr.length === 6 && tokenStr.trim().length === 6) {
            const user = {
                email,
                token: tokenStr,
            };

            console.log(tokenStr)

            dispatch(verifyEmailAction(user));


        } else {
            toast.error("Please enter full 6-digit code.");
        }
    };

    const resend = () => {
        if (!email) {
            toast.error("Credentials lost. Please Login again");
            return;
        }
        dispatch(resendEmailAction({ email }));
    };

    useEffect(() => {
        setEmail(localStorage.getItem("email"));
    }, []);

    useEffect(() => {
        if (error && error !== "Please login to access this resource") {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (isAuthenticated) {
            navigate("/");
        }
    }, [error, dispatch, isAuthenticated, navigate]);

    useEffect(() => {
        if (email) {
            dispatch(verifyEmailTimeAction({ email }));
        }
        let timer;
        if (!email) {
            timer = setTimeout(() => {
                navigate("/login");
            }, 500);
        }
        return () => clearTimeout(timer);
    }, [email, dispatch, navigate]);

    useEffect(() => {
        if (message) {
            toast.info(message);
            dispatch({type:RESEND_EMAIL_RESET})
        }
        if (message && resendEmailTime) {
            settingTimefunction(resendEmailTime);
        }
    }, [message, resendEmailTime,dispatch]);

    useEffect(() => {
        if (expiryTime) {
            settingTimefunction(expiryTime);
        }
    }, [expiryTime]);

    const settingTimefunction = (expiryTimeParaMeter) => {
        if (!expiryTimeParaMeter) {
            console.error("No expiryTime received");
            return;
        }
        const expiryDate = new Date(expiryTimeParaMeter).getTime();
        const now = Date.now();
        if (isNaN(expiryDate)) {
            console.error("Invalid expiry date:", expiryTimeParaMeter);
            return;
        }
        let remainingSeconds = Math.floor((expiryDate - now) / 1000);
        if (remainingSeconds < 0) remainingSeconds = 0;
        setTime(remainingSeconds);
    };


    return (
        <Fragment>
            {loading || resendEmailLoading || verifyEmailLoading ? (
                <Loader />
            ) : (
                <section className="flex-center min-h-[100vh]">
                    <div className="flex flex-col justify-center items-center">
                        <img src={Img} alt="email" className="w-[13vmax]" />
                        <h4 className=" text-[3vmax] lg:text-[1.8vmax] font-3 font-bold">
                            Verify your <span className="text-[var(--color-2)]">Email</span>
                        </h4>
                        <p className="pt-[0.7vmax] text-[1.5vmax] lg:text-[1.2vmax]">
                            We've sent a code to{" "}
                            <span className="font-extrabold text-[1.2vmax]">&nbsp;{email}</span>
                        </p>

                        {/* 6 Digit Code Inputs */}
                        <div className="flex-center gap-[1vmax] py-[1vmax]">
                            {codes.map((code, index) => (
                                <input
                                    key={index}
                                    // callback ref stores DOM node into inputRefs.current array
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    type="text"
                                    autoComplete="one-time-code"
                                    maxLength={1}
                                    value={code}
                                    onChange={(e) => handleChange(index, e)}
                                    onPaste={handlePaste}
                                    className="w-10 h-10 text-center border border-gray-400 rounded-md focus:border-[var(--color-2)] bg-transparent focus:outline-none text-[2.8vmax] lg:text-[1.2vmax]"
                                />
                            ))}
                        </div>

                        <div className="resendEmail text-[1.8vmax] lg:text-[1.2vmax] ">
                            Didn't get the code?{" "}
                            <button className="text-[var(--color-2)] font-bold" onClick={resend}>
                                Click to Resend
                            </button>
                        </div>

                        <h4 className="py-[1vmax] text-[2.5vmax] lg:text-[1.2vmax]">{ActuallTime}</h4>

                        <button
                            className="my-[2vmax] py-[0.7vmax] px-[2vmax] rounded-[2vmax] text-white font-bold shadow-2 block text-[1.8vmax] lg:text-[1.2vmax]"
                            onClick={handleSubmit}
                            style={{
                                cursor: ActuallTime === "00:00" ? "not-allowed" : "pointer",
                                background: ActuallTime === "00:00" ? "grey" : "var(--gradient)",
                            }}
                            disabled={ActuallTime === "00:00"}
                        >
                            Verify
                        </button>
                    </div>
                </section>
            )}
        </Fragment>
    );
};

export default VerifyEmail;
